import { render, staticRenderFns } from "./WfSettings.vue?vue&type=template&id=845b34a8&scoped=true"
import script from "./WfSettings.vue?vue&type=script&lang=js"
export * from "./WfSettings.vue?vue&type=script&lang=js"
import style0 from "./WfSettings.vue?vue&type=style&index=0&id=845b34a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845b34a8",
  null
  
)

export default component.exports